import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './MobileGiveBar.module.css';

// Routes where a floating Give button would be redundant or odd:
// the donor portal and the post-gift thank-you page.
const HIDDEN_ROUTES = ['/giving', '/thank-you'];

/**
 * Floating Give button — mobile/tablet only (hidden >= 961px where the nav
 * already shows an inline Give button). Persistent so donors never have to
 * hunt for it. Hidden while the give modal is open (the modal is a bottom
 * sheet on mobile and would otherwise overlap it).
 */
export default function MobileGiveBar({ onGive, hidden }) {
  const { pathname } = useLocation();
  const suppress = hidden || HIDDEN_ROUTES.includes(pathname);

  return (
    <AnimatePresence>
      {!suppress && (
        <motion.button
          type="button"
          className={styles.fab}
          onClick={onGive}
          aria-label="Give to Revive Worship"
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 26 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          Give <span aria-hidden="true">→</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
